/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Research_Library_TitleInputs */

const en_research_library_title = /** @type {(inputs: Research_Library_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library`)
};

/**
* | output |
* | --- |
* | "Library" |
*
* @param {Research_Library_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const research_library_title = /** @type {((inputs?: Research_Library_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Research_Library_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_research_library_title(inputs)
});